import { createFeatureSelector, createSelector } from '@ngrx/store';
import { filter } from 'lodash';

import { FolderRouterSelectors } from '@lockton-apps/shared/data-access/router';

import {
  DOCUMENTS_FEATURE_KEY,
  DocumentsState,
  documentsAdapter,
} from './documents.reducer';

// Lookup the 'Documents' feature state managed by NgRx
export const selectDocumentsState = createFeatureSelector<DocumentsState>(
  DOCUMENTS_FEATURE_KEY
);

const { selectAll, selectEntities } = documentsAdapter.getSelectors();

export const selectDocumentsLoaded = createSelector(
  selectDocumentsState,
  (state: DocumentsState) => state.loaded
);

export const selectDocumentsError = createSelector(
  selectDocumentsState,
  (state: DocumentsState) => state.error
);

export const selectAllDocuments = createSelector(
  selectDocumentsState,
  (state: DocumentsState) => selectAll(state)
);

export const selectDocumentsByRoutedFolderId = createSelector(
  selectAllDocuments,
  FolderRouterSelectors.selectRoutedId,
  (documents, routedFolderId) =>
    filter(
      documents,
      (document) => document.documentFolderId === routedFolderId
    )
);

export const selectDocumentsEntities = createSelector(
  selectDocumentsState,
  (state: DocumentsState) => selectEntities(state)
);

export const selectSelectedId = createSelector(
  selectDocumentsState,
  (state: DocumentsState) => state.selectedId
);

export const selectTags = createSelector(
  selectDocumentsState,
  (state: DocumentsState) => state.tags
);

export const selectEntity = createSelector(
  selectDocumentsEntities,
  selectSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined)
);

export const selectAllVisibleToClientDocuments = createSelector(
  selectAllDocuments,
  (documents) => filter(documents, { isVisibleToContact: true })
);
